import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import styles from "../../../../services/ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>


        <h3 className={classes.title}>
Measurecamp Auckland 2022
</h3>
<p>
The third <a href="https://auckland.measurecamp.org/">Measurecamp Auckland</a> event occured on June 18th 2022. Tribalism was there to join in the fun at the fisrt  Measurecamp in the southern hemisphere since October 2019 in Sydney.  Ther was a turnout of roughly 80 attendees, sadly, but thanfully as well including a small group from Australia. 
</p>
<p>
The major topics at the conference were 1) Bidding on brand terms with paid search and 2) GA4. We were interested in <a href="https://www.linkedin.com/in/chriscarternyc/Chris Carter">Chris Carter’s</a> new zealand wide experiments that conclusively showed overall site traffic will drop by ~10% when brand ads are turned off. It seems the reasons for this are a) competitors taking your spot and b) the increased clickability and real estate of having ads and organic versus organic alone. Nice work Chris!
</p>
<p>
From our side Scott presented an experimental talk called “Whiteboards, AI and Analog Computing”. Scott tried to make the talk almost like a theatre or demonstration, by writing code directly onto a wide board and then transcribing it via google lens to the website and then launching into a description of how powerful AI is becoming and the advances of analog computing to deliver tiny chips to do specific AI tasks.

Thumbs up to the New Zealand crew and we look forward to the next Measurecamp in <a href = "https://sydney.measurecamp.org/">Sydney</a> on October 22, where the entire Tribalism team will be in attendance.

 </p>
 </GridItem>
 <div style={{textAlign: "center",maxWidth:"800px",width:"100%"}}>
        <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={6}>     
                  <img
                    src="/img/posts/2022-07-14-tribalism-news-july2022/akl20221.jpg"
                    alt="..."
                    className={imgClasses}
                  />
                  
                  <p><br></br><i>Auckland Measurecamp 2022</i></p>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>     
                  <img
                    src="/img/posts/2022-07-14-tribalism-news-july2022/akl20222.jpg"
                    alt="..."
                    className={imgClasses}
                  />
                  
                  <p><br></br><i>Auckland Measurecamp 2022</i></p>
            </GridItem>
            </GridContainer>
        </div>

<GridItem xs={12} sm={8} md={8}>
        <h3 className={classes.title}>
  Bizcap’s new mega list post
</h3>
<p>

During this month we have worked with Bizcap to create and deliver the amazing” <a href="https://www.bizcap.com.au/useful-information/61-small-business-tips-in-2022/">61 Small Business Tips</a> blog post. We created a complete custom blog post page template for this wordpress design - given the huge size and different requirements of this blog post. We also added in filter and custom field options - so users can filter through the big list to the sections most appropriate to them. Design elements were chosen to match Bizcaps colours but also the target audience and topics of interest to readers. We are really proud of this work and hope it leads to great organic success for Bizcap.
 </p>

 </GridItem>
 <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>

<GridItem xs={12} sm={12} md={12}>     
      <img
        src="/img/posts/2022-07-14-tribalism-news-july2022/biz11.jpg"
        alt="..."
        className={imgClasses}
      />
      
      <p><br></br><i>Bizcap's amazing new content piece</i></p>
</GridItem>

</div>

<GridItem xs={12} sm={8} md={8}>




 <h3 className={classes.title}>
Scott at Web Analytics Wednesday
</h3>

<p>
On Wednesday 18th May, Scott was a panellist for the Industry GA4 discussion at the Wharf Hotel in Melbourne. It was an interesting chat amongst peers. Scott believes GA4 was created for a variety of reasons, but the main one is for Google to respond to any privacy concerns that have been created by recent legislation in Europe, in particular GDPR. Indeed in recent times, individual countries such as Austria have deemed the old version of google analytics to be in contravention of GDPR…
</p>

        </GridItem>
       
       
        <div style={{textAlign: "center",maxWidth:"600px",width:"100%"}}>

<GridItem xs={12} sm={12} md={12}>     
      <img
        src="/img/posts/2022-07-14-tribalism-news-july2022/waw1.jpg"
        alt="..."
        className={imgClasses}
      />
      
      <p><br></br><i>Scott waxing lyrical on GA4</i></p>
</GridItem>

</div>


      </GridContainer>
    </div>
  );
}
